export const CATALOG_PATH_SEPARATOR = "catalog";
